<template>
  <div class="bg-white p-4 w-full rounded-lg">
    <div
      v-for="(question, index) in questionsList"
      :key="index"
      :class="[
        { 'rounded-b-none': index < questionsList.length - 1 },
        {
          '!border-red-500':
            formIncompleteItems &&
            (formIncompleteItems[question?.question_id] || formIncompleteItems[question?.question_text]) &&
            submissionAttempted
        }
      ]"
      :style="{ backgroundColor: `${color}10`, borderColor: color }"
      class="p-4 mb-4 w-full my-2 border rounded-lg relative">
      <div
        :id="`${
          question.type == 'single_choice' ||
          question.type == 'multiple_choice' ||
          question.type == 'text_response' ||
          question.type == 'text_area' ||
          question.type == 'url' ||
          question.type == 'nps' ||
          question.type == 'csat'
            ? `${question.question_id}`
            : `${question.question_text}`
        }`"
        class="absolute z-10 w-full h-10 opacity-0 -top-10" />

      <div class="text-common-grey text-sm mb-4">
        {{ $t("Question") }} {{ index + 1 }} <span v-if="!question.required" class="ml-0"> ({{ $t("Not required") }}) </span>
        <span v-else class="text-red-600"> *</span>
      </div>
      <div class="font-medium mb-4">
        {{ question.question_text }}
      </div>

      <div v-if="question.type == 'text_response'">
        <TextInput
          v-model="question.value"
          :value="question.value"
          :disabled="readOnly"
          label=""
          :classes="'w-full'"
          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
          name="name"
          type="text"
          :placeholder="readOnly ? $t('No response') : $t('Start Typing')" />
      </div>

      <div v-if="question.type == 'text_area'">
        <TextArea
          v-model="question.value"
          :value="question.value"
          :disabled="readOnly"
          label=""
          :classes="'w-full'"
          class="bg-transparent"
          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
          name="name"
          type="text"
          :placeholder="readOnly ? $t('No response') : $t('Start Typing')" />
      </div>

      <div v-if="question.type == 'url'">
        <TextInput
          v-model="question.value"
          :value="question.value"
          :disabled="readOnly"
          label=""
          :classes="'w-full'"
          :input-classes="`appearance-none block w-full px-3 py-2 border ${
            validateUrl(question.value) ? '' : 'border-red-500'
          }  rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm`"
          name="name"
          type="text"
          :placeholder="readOnly ? $t('No response') : $t('Start Typing')" />
      </div>

      <div v-if="question.type == 'nps'">
        <div :class="{ 'pointer-events-none': readOnly }" class="">
          <div style="text-align: center" class="m-0 text-center">
            <table
              v-for="nps_index in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
              :key="nps_index"
              border="0"
              cellpadding="0"
              cellspacing="0"
              style="min-width: 31px; height: 31px; display: inline-block"
              height="44"
              class="inline-block">
              <tbody class="">
                <tr class="">
                  <td
                    align="center"
                    valign="middle"
                    height="40"
                    :class="[nps_10[nps_index], { '!opacity-100 scale-[110%]': parseInt(question.value) === nps_index }]"
                    class="min-w-[40px] m-0 border-solid rounded-md cursor-pointer hover:scale-[110%] hover:opacity-100 opacity-50 transition-all border-stone-300">
                    <div @click="setValue(nps_index, question)">
                      <span style="color: rgb(255, 255, 255); text-align: -webkit-center" class="text-white">{{ nps_index }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'csat'">
        <div :class="{ 'pointer-events-none': readOnly }" class="">
          <div style="text-align: center" class="m-0 text-center">
            <table
              v-for="csat_index in [0, 1, 2, 3, 4, 5]"
              :key="csat_index"
              border="0"
              cellpadding="0"
              cellspacing="0"
              style="min-width: 31px; height: 31px; display: inline-block"
              height="44"
              class="inline-block">
              <tbody class="">
                <tr class="">
                  <td
                    align="center"
                    valign="middle"
                    height="40"
                    :class="[nps_5[csat_index], { '!opacity-100 scale-[110%]': parseInt(question.value) === csat_index }]"
                    class="min-w-[40px] m-0 border-solid rounded-md cursor-pointer hover:scale-[110%] hover:opacity-100 opacity-50 transition-all border-stone-300">
                    <div @click="setValue(csat_index, question)">
                      <span style="color: rgb(255, 255, 255); text-align: -webkit-center" class="text-white">{{ csat_index }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'bar_rating'" :class="{ 'pointer-events-none': readOnly }">
        <div class="flex w-full bg-white border border-gray-300 rounded-lg dark:border-dark-divider-border dark:bg-dark-box-background">
          <div class="w-full px-2 pt-2">
            <input
              :disabled="readOnly"
              :value="question.value"
              type="range"
              min="0"
              max="10"
              class="w-full h-4 overflow-hidden bg-gray-200 rounded-lg appearance-none"
              @input="
                ($event) => {
                  question.value = $event.target.value
                }
              ">
            <ul class="flex justify-between text-xs text-gray-600 range-labels dark:text-common-grey">
              <li>0</li>
              <li v-for="i in 10" :key="i">
                {{ i }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'star_rating'" class="flex w-full dark:border-dark-divider-border rounded-lg h-full py-2.5">
        <div class="flex flex-grow w-full">
          <div class="flex-1" />
          <div class="flex justify-start w-full pl-2">
            <span
              v-for="i in 5"
              :key="i"
              @click="
                () => {
                  question.value = i
                }
              ">
              <svg
                class="block w-7 h-7 mr-2"
                :class="[
                  { 'cursor-pointer': !readOnly },

                  question.value >= i
                    ? question.value >= 4
                      ? 'text-status-success-green'
                      : question.value >= 3
                        ? 'text-status-warning-yellow'
                        : 'text-status-error-red'
                    : 'text-gray-300'
                ]"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
              </svg>
            </span>
            <div v-if="!readOnly" class="h-6 ml-4 mr-2 rounded-full btn cancel-btn" @click="question.value = 0">
              {{ $t("Clear") }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'number'">
        <TextInput
          v-model="question.value"
          :disabled="readOnly"
          :value="question.value"
          :is-box-background="true"
          :show-label="false"
          :auto-focus="false"
          input-classes="appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light bg-white focus:border-blue-light sm:text-sm"
          name="name"
          type="number"
          :placeholder="$t('Enter value')"
          label=""
          @input="question.value = $event.target.value" />
      </div>

      <div v-if="question.type == 'date'" class="rounded-md shadow-sm">
        <DatePicker
          v-model="question.value"
          :disabled="readOnly"
          :is-dark="$store.state.ui.darkMode"
          class="bg-white dark:bg-dark-screen-background"
          is-inline
          mode="date"
          :popover="{ visibility: 'click' }">
          <template #default="{ inputValue, inputEvents }">
            <div class="relative">
              <svg
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="absolute w-4 h-full mx-2 text-gray-600 pointer-events-none">
                <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>

              <input
                id="d_date"
                :disabled="readOnly"
                :value="inputValue"
                autocomplete="off"
                class="w-full h-10 px-10 pl-8 pr-2 transition ease-in-out border rounded-lg outline-none text-light-body-text dark:text-dark-body-text border-light-divider-border dark:border-dark-divider-border focus:ring-1 focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue duration-side-menu-transition-duration"
                :class="['bg-light-screen-background dark:bg-dark-box-background']"
                v-on="inputEvents"
                @input="
                  $utils.debounce(() => {
                    question.value = $event.target.value
                  }, 800)
                ">
            </div>
          </template>
        </DatePicker>
      </div>

      <div v-if="question.type == 'single_choice'" class="ml-6">
        <div v-for="(choice, choice_index) in question.choices" :key="choice_index" class="mb-2">
          <div class="flex items-center">
            <div :class="{ 'cursor-pointer': !readOnly }" @click="question.value = choice">
              <input
                :checked="question.value == choice"
                type="checkbox"
                name="truncate"
                :class="`ml-2 form-checkbox rounded-full !pointer-events-none text-[#2DA7D7] dark:text-dark-brand-blue ${checked_bg_color}  dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[1px] focus:ring-0 ring-dark/0 border-gray-200 w-6 h-6 transition ease-in-out duration-side-menu-transition-duration mr-4`">
            </div>

            <div class="w-full bg-white p-2 px-2 rounded-lg mt-0.5">
              {{ choice }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'multiple_choice'" class="ml-6">
        <div v-for="(choice, choice_index) in question.choices" :key="choice_index" class="mb-2">
          <div class="flex items-center">
            <div :class="{ 'cursor-pointer': !readOnly }" @click="multipleQuestionChoiceClick(question, choice)">
              <input
                :checked="question.values.includes(choice)"
                type="checkbox"
                name="truncate"
                class="ml-2 form-checkbox !pointer-events-none text-[#2DA7D7] dark:text-dark-brand-blue checked:bg-[#2DA7D7] dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[1px] focus:ring-0 ring-dark/0 border-gray-200 w-6 rounded-sm h-6 transition ease-in-out duration-side-menu-transition-duration mr-4">
            </div>

            <div class="w-full bg-white p-2 px-2 rounded-lg mt-0.5">
              {{ choice }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'single_choice_grid'" class="w-full">
        <div class="w-[100%] flex overflow-auto ml-44">
          <div class="flex">
            <div v-for="(choice, grid_choice_index) in question.choices" :key="grid_choice_index" class="w-28 mr-4 text-center">
              {{ choice }}
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div v-for="(metric, metric_index) in question.metrics" :key="metric_index" class="bg-white p-2 rounded-lg mb-2">
            <div class="flex">
              <div class="w-44">
                {{ metric }}
              </div>
              <div
                v-for="(metric_choice, grid_metric_choice_index) in question.choices"
                :key="grid_metric_choice_index"
                class="w-28 mr-4 flex text-center items-center justify-center">
                <div :class="{ 'cursor-pointer': !readOnly }" @click="question.values[metric_index] = metric_choice">
                  <input
                    :checked="question.values[metric_index] == metric_choice"
                    type="checkbox"
                    name="truncate"
                    class="rounded-full !pointer-events-none relative right-2 form-checkbox text-[#2DA7D7] dark:text-dark-brand-blue checked:bg-[#2DA7D7] dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-gray-200 w-6 h-6 transition ease-in-out duration-side-menu-transition-duration">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="question.type == 'multiple_choice_grid'" class="w-full">
        <div class="w-[100%] flex overflow-auto ml-44">
          <div class="flex">
            <div v-for="(choice, grid_choice_index) in question.choices" :key="grid_choice_index" class="w-28 mr-4 text-center">
              {{ choice }}
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div v-for="(metric, metric_index) in question.metrics" :key="metric_index" class="bg-white p-2 rounded-lg mb-2">
            <div class="flex">
              <div class="w-44">
                {{ metric }}
              </div>
              <div
                v-for="(metric_choice, grid_metric_choice_index) in question.choices"
                :key="grid_metric_choice_index"
                class="w-28 mr-4 flex text-center items-center justify-center">
                <div
                  :class="{ 'cursor-pointer': !readOnly }"
                  @click="multipleGridQuestionChoiceClick(question, metric_index, metric_choice)">
                  <input
                    :checked="question.values[metric_index].includes(metric_choice)"
                    type="checkbox"
                    name="truncate"
                    class="rounded-sm !pointer-events-none relative right-2 form-checkbox text-[#2DA7D7] dark:text-dark-brand-blue checked:bg-[#2DA7D7] dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-gray-200 w-6 h-6 transition ease-in-out duration-side-menu-transition-duration">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextArea from "@/components/shared/TextArea.vue"
import TextInput from "@/components/shared/TextInput.vue"

import { DatePicker } from "v-calendar"

export default {
  components: {
    TextArea,
    DatePicker,
    TextInput
  },
  props: {
    questionsList: null,
    readOnly: null,
    formIncompleteItems: null,
    submissionAttempted: null,
    color: null
  },
  emits: [],
  data() {
    return {
      nps_10: {
        // for 10 scale nps score
        0: "bg-red-500",
        1: "bg-orange-400",
        2: "bg-orange-500",
        3: "bg-orange-600",
        4: "bg-amber-300",
        5: "bg-yellow-400",
        6: "bg-amber-400",
        7: "bg-lime-400",
        8: "bg-lime-500",
        9: "bg-lime-600",
        10: "bg-emerald-700"
      },
      nps_5: {
        // for 5 scale nps score
        0: "bg-red-500",
        1: "bg-orange-500",
        2: "bg-amber-400",
        3: "bg-lime-500",
        4: "bg-lime-600",
        5: "bg-emerald-700"
      }
    }
  },

  computed: {
    checked_bg_color() {
      return `checked:bg-[${this.color}]`
    }
  },
  watch: {},

  created() {},
  methods: {
    setValue(value, question) {
      question.value = value
    },
    validateUrl(url) {
      if (!url) {
        return true
      }
      let regex = /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){0,1}([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/
      return url.match(regex)
    },
    multipleQuestionChoiceClick(question, choice) {
      const question_values = question.values
      const choice_index = question_values.findIndex((v) => v == choice)
      if (choice_index !== -1) {
        question_values.splice(choice_index, 1)
      } else {
        question_values.push(choice)
      }
    },

    multipleGridQuestionChoiceClick(question, metric_index, metric_choice) {
      const question_values = question.values[metric_index]
      const choice_index = question_values.findIndex((v) => v == metric_choice)

      if (choice_index !== -1) {
        question_values.splice(choice_index, 1)
      } else {
        question_values.push(metric_choice)
      }
    }
  }
}
</script>
